"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../icon/Icon"));

var _IconButton = _interopRequireDefault(require("../icon-button/IconButton"));

var _Banner = require("./Banner.style");

var _utils = require("../lib/utils");

var _excluded = ["type", "iconName", "title", "description", "onDismiss"];
var typeIconsMap = {
  info: {
    iconName: 'InfoCircle',
    color: (0, _utils.getPalette)('primary', '300')()
  },
  warning: {
    iconName: 'Alert',
    color: (0, _utils.getPalette)('orange', '300')()
  },
  error: {
    iconName: 'CloseCircle',
    color: (0, _utils.getPalette)('red', '300')()
  },
  success: {
    iconName: 'CheckCircle',
    color: (0, _utils.getPalette)('green', '300')()
  }
};

var Banner = function Banner(_ref) {
  var type = _ref.type,
      iconName = _ref.iconName,
      title = _ref.title,
      description = _ref.description,
      onDismiss = _ref.onDismiss,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Banner.StyledBanner, (0, _extends2["default"])({}, props, {
    type: type,
    color: typeIconsMap[type].color
  }), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    iconName: iconName ? iconName : typeIconsMap[type].iconName,
    size: 24,
    fill: typeIconsMap[type].color
  })), /*#__PURE__*/_react["default"].createElement("div", null, title && /*#__PURE__*/_react["default"].createElement(_Banner.StyledTitle, null, title), description && /*#__PURE__*/_react["default"].createElement(_Banner.StyledDesc, null, description)), onDismiss && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    className: "eui-b-dismiss",
    variant: "plain",
    size: 26,
    onClick: onDismiss
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    iconName: 'Close',
    size: 16
  })));
};

Banner.defaultProps = {
  shadow: false,
  type: 'info'
};
Banner.propTypes = {
  type: _propTypes["default"].oneOf(['info', 'warning', 'error', 'success']).isRequired,
  className: _propTypes["default"].string,
  iconName: _propTypes["default"].string,
  description: _propTypes["default"].string,
  title: _propTypes["default"].string,

  /**
   * eg: `<>
   * <Button variant='plain'>Button</Button>
   * <Button variant='outlined' ml={2}>Button</Button>
   * </>`
   */
  shadow: _propTypes["default"].bool,
  onDismiss: _propTypes["default"].func
};
var _default = Banner;
exports["default"] = _default;